import { ArticleCuttingParams } from "../../models/articleModel";
import ArticleService from "../services/ArticleService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";
import { db } from "./db";

export const fillArticleCuttingParamTroDB = () => {
    return db.articlesCuttingParamsTro.count(async function (count: number) {
        if (count > 0) {
            //ArticleCuttingParamsTro Already populated
        } else {
            //console.log("ArticleCuttingParamsTro Database is empty. Populating from ajax call...");
            store.dispatch(setDBLoadingState(true));
            await ArticleService.getArticlesCuttingParamsTro()
                .then((data) => {
                    //console.log("Got ajax response. We'll now add the objects.");
                    //console.log("Calling bulkAdd() to insert objects...");
                    if (data) {
                        let formattedData: ArticleCuttingParams[] = formatDataForDB(data);
                        //console.log(formattedData)
                        return db.articlesCuttingParamsTro.bulkAdd(formattedData);
                    }
                })
                .then(() => {
                    //Done populating
                    return db.timestamps.add({ name: "articlesCuttingParamsTro", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}

export const formatDataForDB = (data: string | any[]) => {
    let formattedData: ArticleCuttingParams[] = [];
    for (let i = 0; i < data.length; ++i) {
        formattedData.push({
            id: i,
            ident: data[i][0],
            pos: data[i][1],
            data: data[i][2],
        })
    }
    return formattedData
}

export const deleteArticleCuttingParamTroDB = () => {
    return db.articlesCuttingParamsTro.clear().then(() => {
        //Database successfully cleared
    }).catch((err) => {
        //Could not clear database
    })
}

export const updateArticleCuttingParamTroDB = async () => {
    await ArticleService.getArticlesCuttingParamsTro()
        .then(async (data) => {
            if (data) {
                await deleteArticleCuttingParamTroDB().then(() => {
                    let formattedData: ArticleCuttingParams[] = formatDataForDB(data);
                    //console.log(formattedData)
                    return db.articlesCuttingParamsTro.bulkPut(formattedData);
                })
                
            }
        })
        .then(() => {
            //Done refilling
            return db.timestamps.put({ name: "articlesCuttingParamsTro", timestamp: String(new Date()) })
        })
        .catch(err => console.log(err));
}